import React from "react";

import { useDemoState, View } from "@/state/demoState";

import { ToggleButtons } from "../components/ToggleButtons/ToggleButtons";

import css from "./Toolbar.module.css";
import { Button } from "../components/Button/Button";
import { Row } from "../components/Panel/Row";

const VIEW_OPTIONS: { label: string; value: View }[] = [
    {
        label: "2D",
        value: "2d",
    },
    {
        label: "3D",
        value: "3d",
    },
];

export const Toolbar: React.FC = () => {
    const view = useDemoState((state) => state.view);
    const step = useDemoState((state) => state.step);
    const setStep = useDemoState((state) => state.setStep);
    const setView = useDemoState((state) => state.setView);

    const handleEditRoom = () => {
        setStep("room setup");
        setView("2d");
    };

    return (
        <div className={css.main}>
            <Row gap="40px">
                <ToggleButtons options={VIEW_OPTIONS} onChange={setView} value={view} />
                {step !== "room setup" && (
                    <Button variant="secondary" size="small" onClick={handleEditRoom}>
                        Редактировать комнату
                    </Button>
                )}
            </Row>
        </div>
    );
};
